module.exports = __webpack_public_path__ + "img/logo_dark@2x.b7531544.png";